import checkoutDataReducer, { initialState as checkoutDataInitialState } from './checkoutDataReducer';
import currentUserReducer, { initialState as currentUserInitialState } from './currentUserReducer';
import checkoutWizardReducer, { initialState as checkoutWizardInitialState } from './checkoutWizardReducer';
import finalWizardReducer, { initialState as finalWizardInitialState } from './finalWizardReducer';
import snapSellWizardReducer, { initialState as snapSellWizardInitialState } from './snapSellWizardReducer';
import publishersReducer, { initialState as publishersInitialState } from './publishersReducer';
import countriesReducer, { initialState as countriesInitialState } from './countriesReducer';
import submissionFormReducer, { initialState as submissionFormInitialState } from './submissionFormReducer';
import eventbriteReducer, { initialState as eventbriteInitialState } from './eventbriteReducer';
import appReducer, { initialState as appInitialState } from './appReducer';
import formHooks from './formHooksReducer';
import formLocalStorageReducer from './formLocalStorageReducer';
import { reducer as formReducer } from 'redux-form';
import { fromJS, Map } from 'immutable';

const staticArrayReducer = (state = []) => state;
const staticMapReducer = (state = {}) => fromJS(state);

export default {
  app: appReducer,
  checkoutData: checkoutDataReducer,
  currentUser: currentUserReducer,
  checkoutWizard: checkoutWizardReducer,
  finalWizard: finalWizardReducer,
  snapSellWizard: snapSellWizardReducer,
  publishers: publishersReducer,
  countries: countriesReducer,
  submissionForm: submissionFormReducer,
  form: formReducer.plugin({ eventSubmission: (state, action) => formLocalStorageReducer(formHooks(state, action), action) }),
  currencies: staticArrayReducer,
  categories: staticArrayReducer,
  timeZones: staticArrayReducer,
  pricingTiers: staticMapReducer,
  subscriptionTiers: staticMapReducer,
  urlTypes: staticArrayReducer,
  config: staticMapReducer,
  eventbrite: eventbriteReducer,
};

export const initialStates = {
  app: appInitialState,
  checkoutData: checkoutDataInitialState,
  currentUser: currentUserInitialState,
  checkoutWizard: checkoutWizardInitialState,
  finalWizard: finalWizardInitialState,
  snapSellWizard: snapSellWizardInitialState,
  publishers: publishersInitialState,
  countries: countriesInitialState,
  submissionForm: submissionFormInitialState,
  eventbrite: eventbriteInitialState,
  config: new Map(),
};



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/reducers/index.js